import React, { useEffect } from 'react';
import A1ConnectEmailCheckModal from './A1ConnectEmailCheckModal';
import { useDisclosure } from '@chakra-ui/react';
import { useState } from 'react';
import { CONNEXION_PATH, getAbsolutePath } from 'lib/paths';
import axios from 'axios';

const A1ConnectWC = ({ inscriptionPath }) => {
  const [currentEmail, setCurrentEmail] = useState(undefined);
  const [emailableAPIResponse, setEmailableAPIResponse] = useState(undefined);
  const [userSSOToken, setUserSSOToken] = useState(undefined);
  const [ssoUrl, setSsoUrl] = useState(undefined);

  useEffect(() => {
    const getToken = async () => {
      const res = await axios.post(
        getAbsolutePath('/api/auth/sso/request-token'),
        { targetUrl: CONNEXION_PATH }
      );
      setUserSSOToken(res.data.token);
      setSsoUrl(res.data.ssoUrl);
    };

    getToken();
  }, []);

  useEffect(() => {
    if (ssoUrl) {
      const scriptSrc = `${ssoUrl}/wc-registration.umd.js`;
      if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
        const script = document.createElement('script');
        script.src = scriptSrc;
        script.async = true;
        script.onload = () => {
          const webComponent = document.querySelector('a1c-wc-registration');
          webComponent.addEventListener('emailChecked', handleEmailChecked);
          webComponent.addEventListener('fetch', handleFetchData);
        };
        document.body.appendChild(script);
      }
    }

    return () => {
      const webComponent = document.querySelector('a1c-wc-registration');
      webComponent.removeEventListener('emailChecked', handleEmailChecked);
      webComponent.removeEventListener('fetch', handleFetchData);
    };
  }, [ssoUrl]);

  useEffect(() => {
    if (emailableAPIResponse) {
      if (emailableAPIResponse?.data?.state !== 'deliverable') {
        onOpenModal();
      } else {
        emailableAPIResponse.submit();
      }
    }
  }, [emailableAPIResponse]);

  const handleEmailChecked = (event) => {
    console.log('event', event);

    setEmailableAPIResponse(event.detail[0]);
    setCurrentEmail(event.detail[0].data.email);
  };

  const handleFetchData = async (event) => {
    const { detail } = event;
    if (!detail) {
      return;
    }

    const { sessionJwt } = detail?.[0];
    if (!sessionJwt) {
      return;
    }

    const res = await axios.post(
      getAbsolutePath('/api/auth/sso/auth-done'),
      {
        profile_jwt: sessionJwt,
        noRedirect: true,
      },
      {
        params: {
          targetUrl: CONNEXION_PATH,
        },
      }
    );

    const resData = res.data;
    const targetUrlToUse = resData.targetUrl;
    window.location.href = `${targetUrlToUse}&redirectUrl=${inscriptionPath}`;
  };

  const handleEmailValidatedByUser = () => {
    emailableAPIResponse.submit();
  };

  const {
    isOpen: isOpenModal,
    onOpen: onOpenModal,
    onClose: onCloseModal,
  } = useDisclosure();

  return (
    <div>
      {currentEmail && (
        <A1ConnectEmailCheckModal
          isOpen={isOpenModal}
          onClose={onCloseModal}
          currentEmail={currentEmail}
          onSubmit={handleEmailValidatedByUser}
        />
      )}
      <a1c-wc-registration
        dev-front-port="8082"
        dev-back-port="3000"
        plateform="inspire"
        auth-req-jwt={userSSOToken ? userSSOToken : undefined}
        logo={getAbsolutePath('/img/logo.svg')}
        platform="inspire"
      />
    </div>
  );
};
export default A1ConnectWC;
